import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    convertUniversalDateTimeToPersianDateTime,
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCardInfoTypeOne,
    RaikoChipTypes,
    RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {Link, useNavigate} from "react-router-dom";
import {MemorialNoteService} from "../../serverService/memorialNoteService/MemorialNoteService";
import {useDebounce} from "@uidotdev/usehooks";
import TableOtherAccessContainer
    from "../../component/tableCreateHelper/tableOtherAccessContainer/TableOtherAccessContainer";

export default function MemorialNotes() {

    let page = 0
    const size = 15

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [selectDisplayType, setSelectDisplayType] = useState(false)
    const [memorialNoteDataList, setMemorialNoteDataList] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const [fullName, setFullName] = useState("");
    const [status, setStatus] = useState(MemorialNoteStatusTypes.ALL.id);

    const nameFilter = useDebounce(fullName, 500);
    const statusFilter = useDebounce(status, 100)

    const service = new MemorialNoteService()

    useEffect(() => {
        getMemorialNoteListFromServer()

    }, [nameFilter, statusFilter]);

    function preparationMemorialNoteTable(number, id, userId, userFullName, messagePreview, likeCount, createdAt, status) {
        return {
            number,
            id,
            userId,
            userFullName,
            messagePreview,
            likeCount,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            status: status === "AWAITING_FOR_REVIEW" ?
                <RaikoCustomSimpleChip title={"در حال بررسی"} type={RaikoChipTypes.warning}/> :
                status === "ACCEPTED" ?
                    <RaikoCustomSimpleChip title={"پذیرفته شده"} type={RaikoChipTypes.success}/> :
                    <RaikoCustomSimpleChip title={"رد شده"} type={RaikoChipTypes.error}/>,
            userInfo: <TableOtherAccessContainer>
                <Link to={RouteHelper.UserInformation.globalUrl.replace(":id", userId)}
                      target={"_blank"}
                >
                    <div className={"ic-profile"} onClick={event => {
                        event.stopPropagation();
                        event.preventDefault();
                        window.open(RouteHelper.UserInformation.globalUrl.replace(":id", userId), "_blank")
                    }}>

                    </div>
                </Link>
            </TableOtherAccessContainer>
        }
    }

    function getMemorialNoteListFromServer() {
        setTableLoading(true)
        service.getMemorialNoteList(page, size, nameFilter, statusFilter)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setMemorialNoteDataList([])
                response.data.map((item, index) => {
                    setMemorialNoteDataList(prevState => [
                        ...prevState,
                        preparationMemorialNoteTable(
                            (page * size) + index + 1,
                            item.id,
                            item.userId,
                            item.userFullName,
                            item.messagePreview ? item.messagePreview.slice(0, 50) + "..." : "-",
                            item.likeCount,
                            item.createdAt,
                            item.status,
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    const navigate = useNavigate()

    function showMemorialNoteDetails(memorialNoteId) {
        let _title = ""
        memorialNoteDataList.map((item) => {
            if (item.id === memorialNoteId)
                _title = item.userFullName
        })


        navigate(RouteHelper.MemorialNoteDetails.globalUrl.replace(":id", memorialNoteId),
            {state: {title: _title}, replace: false}
        )
    }
    function handleChangePage(newPage) {
        page= newPage;
        getMemorialNoteListFromServer()
    }


    return (
        <>
            <Helmet><title>{RouteHelper.MemorialNotes.name}</title></Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.MemorialNote.name, ""),
                        raikoBreadCrumbItemGenerator(RouteHelper.MemorialNotes.name, ""),
                    ]}/>
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"دلنوشته ها"}
                            amount={numberOfItems}
                        />
                        <RaikoTableSearchContainer
                            labelText={"نام و نام خانوادگی"}
                            hasFilter
                            value={fullName}
                            setValue={setFullName}
                        >
                            <RaikoGridOneColumn>
                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    value={status}
                                    setValue={setStatus}
                                    items={[
                                        raikoCustomSelectItemGenerator(MemorialNoteStatusTypes.ALL.id, MemorialNoteStatusTypes.ALL.title),
                                        raikoCustomSelectItemGenerator(MemorialNoteStatusTypes.ACCEPTED.id, MemorialNoteStatusTypes.ACCEPTED.title),
                                        raikoCustomSelectItemGenerator(MemorialNoteStatusTypes.REJECTED.id, MemorialNoteStatusTypes.REJECTED.title),
                                        raikoCustomSelectItemGenerator(MemorialNoteStatusTypes.AWAITING_FOR_REVIEW.id, MemorialNoteStatusTypes.AWAITING_FOR_REVIEW.title),
                                    ]}
                                />
                            </RaikoGridOneColumn>

                        </RaikoTableSearchContainer>
                        <RaikoCustomTable
                            header={memorialNoteListHeader}
                            data={memorialNoteDataList}
                            rowClicked={showMemorialNoteDetails}
                            pageCount={pageCount}
                            isLoading={tableLoading}
                            handlePaginationChange={handleChangePage}
                        />
                    </RaikoGridOneColumn>

                </RaikoBaseCardContainer>
            </RaikoBaseContainer>

        </>
    )
}
const memorialNoteListHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "userId",
        label: "شماره کاربر",
    },
    {
        id: "userFullName",
        label: "نام نویسنده"
    },
    {
        id: "messagePreview",
        label: "دلنوشته"
    },
    {
        id: "likeCount",
        label: "تعداد لایک"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
    {
        id: "status",
        label: "وضعبت انتشار"
    },
    {
        id: "userInfo",
        label: "اطلاعات کاربر"
    },
];
export const MemorialNoteStatusTypes = {
    ALL: {
        title: "همه",
        id: "ALL"
    },
    ACCEPTED: {
        title: "پذیرفته شده",
        id: "ACCEPTED"
    },
    REJECTED: {
        title: "رد شده",
        id: "REJECTED"
    },
    AWAITING_FOR_REVIEW: {
        title: "در حال بررسی",
        id: "AWAITING_FOR_REVIEW"
    },
}